module.exports = __webpack_public_path__ + "static/img/yiyuyue.a7549e7b.png";